import React from 'react';

const PARTNERS = [
    { name: 'Emaar Properties', note: "Dubai's largest developer" },
    { name: 'DAMAC Group',      note: 'Luxury real estate' },
    { name: 'Nakheel',          note: 'Palm Jumeirah creators' },
    { name: 'Aldar Properties', note: 'Abu Dhabi leader' },
    { name: 'Dubai Properties', note: 'Integrated developer' },
    { name: 'Meraas',           note: 'Premium lifestyle' },
    { name: 'Select Group',     note: 'Marina specialists' },
    { name: 'Union Properties', note: 'Diversified assets' },
];

const Partners: React.FC = () => (
    <>
        <style>{`
      /* ── Section ── */
      .pt-section {
        background: var(--bg);
        padding: 7rem 0;
        position: relative;
        transition: background 0.4s;
      }
      .pt-section::before {
        content: ''; position: absolute; top: 0; left: 0; right: 0; height: 1px;
        background: linear-gradient(90deg, transparent, var(--border-t), transparent);
      }
      .pt-inner { max-width: 1280px; margin: 0 auto; padding: 0 5rem; }

      /* ── Header ── */
      .pt-head {
        margin-bottom: 4rem;
        display: flex; align-items: flex-end;
        justify-content: space-between; flex-wrap: wrap; gap: 1.5rem;
      }

      /* ── Grid ── */
      .pt-grid {
        display: grid;
        grid-template-columns: repeat(4, 1fr);
        gap: 1px;
        background: var(--border);
      }

      /* ── Card ── */
      .pt-card {
        background: var(--surface);
        padding: 2.6rem 1.8rem;
        display: flex; flex-direction: column;
        align-items: center; gap: 1.1rem;
        cursor: default;
        transition: background 0.3s, transform 0.3s;
      }
      .pt-card:hover { background: var(--surface2); transform: translateY(-3px); }

      /* Icon circle */
      .pt-icon {
        width: 56px; height: 56px;
        border-radius: 50%;
        border: 1.5px solid var(--border-t);
        display: flex; align-items: center; justify-content: center;
        font-family: var(--ff-h);
        font-size: 1.4rem; font-weight: 500;
        color: var(--teal);
        transition: border-color 0.3s, background 0.3s;
      }
      .pt-card:hover .pt-icon {
        border-color: var(--teal);
        background: var(--teal-pale);
      }

      /* Name */
      .pt-name {
        font-family: var(--ff-ui);
        font-size: 0.75rem;        /* fixed: was 0.65 */
        font-weight: 600;
        letter-spacing: 0.10em; text-transform: uppercase;
        color: var(--ink);
        text-align: center;
        transition: color 0.3s;
      }
      .pt-card:hover .pt-name { color: var(--teal); }

      /* Note */
      .pt-note {
        font-family: var(--ff-b);
        font-size: 0.85rem;        /* fixed: was 0.70 */
        font-weight: 400;          /* fixed: was 300 — too thin */
        color: var(--ink3);
        text-align: center;
        line-height: 1.6;
      }

      /* Footer note */
      .pt-note-global {
        text-align: center;
        margin-top: 3rem;
        font-family: var(--ff-b);
        font-size: 0.9rem;         /* fixed: was 0.78 */
        font-weight: 400;          /* fixed: was 300 */
        color: var(--ink3);
        line-height: 1.7;
      }

      /* ── Responsive ── */
      @media (max-width: 900px) {
        .pt-inner { padding: 0 2rem; }
        .pt-grid  { grid-template-columns: repeat(2, 1fr); }
      }
      @media (max-width: 500px) {
        .pt-grid { grid-template-columns: 1fr 1fr; }
        .pt-note { font-size: 0.8rem; }
      }
    `}</style>

        <section id="partners" className="pt-section">
            <div className="pt-inner">

                <div className="pt-head">
                    <div>
                        <p className="sec-label">Trusted By</p>
                        <h2 className="sec-h2">Our Developer <em>Partners</em></h2>
                    </div>
                </div>

                <div className="pt-grid">
                    {PARTNERS.map(p => (
                        <div key={p.name} className="pt-card">
                            <div className="pt-icon">{p.name.charAt(0)}</div>
                            <p className="pt-name">{p.name}</p>
                            <p className="pt-note">{p.note}</p>
                        </div>
                    ))}
                </div>

                <p className="pt-note-global">
                    Collaborating with UAE's most trusted developers to deliver exceptional properties.
                </p>

            </div>
        </section>
    </>
);

export default Partners;